import { Icons as e } from "../Icons/Icons.mjs";
import "react";
import { styled as t } from "styled-components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/ActionCard/ActionSummaryRow.tsx
var i = t.button`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    width: 100%;
    padding: ${({ theme: e }) => `${e.spacing(1.25)} ${e.spacing(1.5)}`};
    border: none;
    border-radius: ${({ theme: e }) => e.radii.md};
    background: transparent;
    cursor: pointer;
    text-align: left;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    transition: background-color ${({ theme: e }) => e.transitions.fast};

    &:hover {
        background-color: ${({ theme: e }) => e.colors.muted};
        color: ${({ theme: e }) => e.colors.foreground};
    }

    &:focus-visible {
        outline: 2px solid ${({ theme: e }) => e.colors.ring};
        outline-offset: -2px;
    }
`, a = t.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    svg {
        width: 16px;
        height: 16px;
    }
`, o = t.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`, s = t.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    svg {
        width: 16px;
        height: 16px;
    }
`, c = ({ label: t, icon: c, onClick: l, className: u }) => /* @__PURE__ */ r(i, {
	type: "button",
	onClick: l,
	className: u,
	children: [
		c ? /* @__PURE__ */ n(a, { children: c }) : null,
		/* @__PURE__ */ n(o, { children: t }),
		/* @__PURE__ */ n(s, { children: /* @__PURE__ */ n(e.ChevronRight, {}) })
	]
});
//#endregion
export { c as ActionSummaryRow };
